enum ExpiryVisibilityTypeIds {
  noExpiryDate = '1030f9ca-5803-46a4-a33a-74439337994a',
  expiryDateOptional = '21377726-827a-4137-b85d-4c56770a410e',
  expiryDateRequired = 'a6bfb733-95c5-4edc-af34-8b7519e82028',
}

export { ExpiryVisibilityTypeIds }
